(function () {
  'use strict';
  let modelFeature;
  function loadModelFeature() {
    if (!modelFeature) modelFeature = new Promise((resolve, reject) => {
      if (!window.Shopify?.loadFeatures) { reject(new Error('Model viewer unavailable')); return; }
      window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: error => error ? reject(error) : resolve() }]);
    }).catch(error => { modelFeature = null; throw error; });
    return modelFeature;
  }
  function init(scope) {
    scope.querySelectorAll('[data-rich-media]').forEach(details => {
      if (details.dataset.mediaReady) return;
      details.dataset.mediaReady = 'true';
      const stage = details.querySelector('[data-media-stage]');
      const status = details.querySelector('[data-media-status]');
      let modelUI;
      let pending = false;
      details.addEventListener('toggle', async () => {
        if (!details.open) {
          stage.querySelector('video')?.pause();
          modelUI?.pause();
          if (details.dataset.mediaType === 'external_video') stage.replaceChildren();
          return;
        }
        if (stage.childElementCount || pending) return;
        pending = true;
        status.hidden = true;
        try {
          if (details.dataset.mediaType === 'model') await loadModelFeature();
          if (!details.open || !details.isConnected) return;
          stage.append(details.querySelector('[data-media-template]').content.cloneNode(true));
          const model = stage.querySelector('model-viewer');
          if (model) modelUI = new window.Shopify.ModelViewerUI(model);
        } catch (error) {
          modelUI = null;
          stage.replaceChildren();
          status.textContent = details.dataset.mediaError;
          status.hidden = false;
        } finally { pending = false; }
      });
    });
    scope.querySelectorAll('[data-campaign-video]').forEach(campaign => {
      if (campaign.dataset.mediaReady) return;
      campaign.dataset.mediaReady = 'true';
      const button = campaign.querySelector('[data-campaign-play]');
      const stage = campaign.querySelector('[data-campaign-stage]');
      const status = campaign.querySelector('[data-campaign-status]');
      let video;
      const paused = () => { button.textContent = button.dataset.playLabel; button.setAttribute('aria-pressed', 'false'); };
      button.addEventListener('click', async () => {
        status.hidden = true;
        if (!video) {
          const mobile = matchMedia('(max-width:760px)').matches;
          const template = (mobile && campaign.querySelector('[data-campaign-mobile]')) || campaign.querySelector('[data-campaign-desktop]');
          stage.append(template.content.cloneNode(true));
          video = stage.querySelector('video');
          video.addEventListener('pause', paused);
          video.addEventListener('ended', paused);
        }
        if (!video.paused) { video.pause(); return; }
        try {
          await video.play();
          button.textContent = button.dataset.pauseLabel;
          button.setAttribute('aria-pressed', 'true');
        } catch (error) {
          paused();
          status.textContent = campaign.dataset.mediaError;
          status.hidden = false;
        }
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (!campaign.isConnected) { observer.disconnect(); return; }
          if (!entries[0].isIntersecting) video?.pause();
        });
        observer.observe(campaign);
      }
      document.addEventListener('visibilitychange', () => { if (document.hidden) video?.pause(); });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
